import React, { useCallback } from "react";

import { Radio } from "antd";
import { useIntl } from "react-intl";

import { EntityType } from "@mapmycustomers/shared";

import RadioGroup from "@app/component/input/RadioGroup";
import EntityTypesSupportedInNewRoutes from "@app/types/dashboard/cards/newRoutes/EntityTypesSupportedInNewRoutes";
import { getEntityTypeDisplayName } from "@app/util/ui";

import { NEW_ROUTES_ENTITY_TYPES, routeTypeToEntityTypeMap } from "./consts";

const OPTION_BOTH = "both";

interface EntityTypeRadioGroupProps {
  disabled?: boolean;
  onChange?: (value: EntityTypesSupportedInNewRoutes[]) => void;
  value?: EntityTypesSupportedInNewRoutes[];
}

const EntityTypeRadioGroup: React.FC<EntityTypeRadioGroupProps> = ({
  disabled,
  onChange,
  value,
}) => {
  const intl = useIntl();
  const selected = value && value.length > 1 ? OPTION_BOTH : value?.[0] ?? EntityType.COMPANY_ROUTE;

  const handleChange = useCallback(
    (value: EntityTypesSupportedInNewRoutes | typeof OPTION_BOTH) => {
      if (value === OPTION_BOTH) {
        onChange?.([EntityType.COMPANY_ROUTE, EntityType.PEOPLE_ROUTE]);
      } else {
        onChange?.([value]);
      }
    },
    [onChange]
  );

  return (
    <RadioGroup disabled={disabled} onChange={handleChange} value={selected}>
      {NEW_ROUTES_ENTITY_TYPES.map((entityType) => (
        <Radio.Button key={entityType} value={entityType}>
          {getEntityTypeDisplayName(intl, routeTypeToEntityTypeMap[entityType], {
            lowercase: false,
            plural: true,
          })}
        </Radio.Button>
      ))}
      <Radio.Button key={OPTION_BOTH} value={OPTION_BOTH}>
        {intl.formatMessage({
          id: "dashboard.editModal.criteria.newRoutes.both",
          defaultMessage: "Both",
          description: "Both entity types radio button",
        })}
      </Radio.Button>
    </RadioGroup>
  );
};

export default EntityTypeRadioGroup;
